"use strict";

exports.__esModule = true;
exports.applyTrailingSlashOption = void 0; // TODO(v5): Remove legacy setting and default to "always"

var applyTrailingSlashOption = function applyTrailingSlashOption(input, option) {
  if (option === void 0) {
    option = "legacy";
  }

  var hasHtmlSuffix = input.endsWith(".html");
  if (input === "/") return input;

  if (hasHtmlSuffix) {
    option = "never";
  }

  if (option === "always") {
    return input.endsWith("/") ? input : input + "/";
  }

  if (option === "never") {
    return input.endsWith("/") ? input.slice(0, -1) : input;
  }

  return input;
};

exports.applyTrailingSlashOption = applyTrailingSlashOption;